"use client";

import { getQualityColor } from "./utils";

export function ChoghadiyaLegend() {
  return (
    <div className="flex flex-wrap justify-center gap-3 text-[11px] font-medium">
      {[
        { label: "Best", quality: "best" },
        { label: "Good", quality: "good" },
        { label: "Neutral", quality: "neutral" },
        { label: "Bad", quality: "bad" },
      ].map(({ label, quality }) => {
        const colors = getQualityColor(quality);
        return (
          <span key={quality} className="flex items-center gap-1.5">
            <span
              className="w-2.5 h-2.5 rounded-full"
              style={{ backgroundColor: colors.text }}
            />
            <span className="text-ish-text-muted">{label}</span>
          </span>
        );
      })}
    </div>
  );
}
